/*
 * @Descripttion: 封装数据请求
 * @Author: juanjuanhui
 * @Date: 2021-05-17 09:25:08
 * @LastEditors: likk 1126919170@qq.com
 * @LastEditTime: 2024-09-25 15:20:49
 */
import request from './request'
const http = {
  /**
   * @descripttion: GET请求
   * @Author: juanjuanhui
   * @Date: 2021-06-23 21:10:32
   * @param {String} url 请求地址
   * @param {Object} params 请求参数
   * @return {*}
   */
  get(url, params) {
    const config = {
      method: 'get',
      url
    }
    if (params) config.params = params
    return request(config)
  },
  /**
   * @descripttion: POST请求
   * @Author: juanjuanhui
   * @Date: 2021-06-23 21:09:01
   * @param {String} url 请求地址
   * @param {Object} params 请求参数
   * @return {*}
   */
  post(url, params, serviceType="") {
    const config = {
      method: 'post',
      url
    }
    if (params) config.data = params
    config.serviceType = serviceType
    return request(config)
  }
}
export default http
